export default __webpack_public_path__ + "static/discord-6ad1e91fd65a884e71a796f3968aaf92.png";